import { Box, Image } from '@chakra-ui/react';

import { CopyIcon } from 'Asset/icon';
import useCopyToClipboard from 'Hook/useCopyToClipboard';
import { TextMedium, TextRegular, TextSemiBold } from 'UiKit/typography';
import { useAppSystem } from 'Store/app';
import { useHostStockPromoState } from 'View/host-stock-promo/state';
import { countAvailableStock } from 'View/host-stock-promo/helper/countAvailableStock';
import getProductImage from 'View/host-stock-promo/helper/getProductImage';

import styles from './styles.module.css';

const CardStock = ({ data }) => {
  const { updateState } = useHostStockPromoState();
  const { onChangeAppSystem } = useAppSystem();
  const availableStock = countAvailableStock(data);
  const stockTextColor = availableStock <= 0 ? 'var(--color-error50)' : 'var(--color-semantic-text)';
  const { copyToClipboard } = useCopyToClipboard();

  const handleCopy = () => copyToClipboard(data?.sku, 'Nomor SKU');

  const handleCardClick = () => {
    updateState({ selectedDetailStock: data });
    onChangeAppSystem({ isHideMobileNavBar: true });
  };

  const stockImage = getProductImage(data?.imagePath);

  return (
    <Box className={styles['card-stock-host__container']} data-testid="card-stock">
      <Box className={styles['stock-image-info__container']}>
        <Box className={styles['stock-image__box']}>
          <Image src={stockImage} width={'100%'} height={'100%'} className={styles['stock-image']} />
        </Box>
        <Box className={styles['product-info__container']}>
          <TextMedium className={styles['product-name__text']} onClick={handleCardClick}>
            {data?.name}
          </TextMedium>
          <Box className={styles['product-detail__container']} onClick={handleCopy}>
            <TextRegular className={styles['product-detail__text']}>
              {data?.brand} | {data?.sku}
            </TextRegular>
            <CopyIcon color="var(--color-primary60)" size="12px" />
          </Box>
        </Box>
      </Box>
      <Box className={styles['stock__container']} onClick={handleCardClick}>
        <TextSemiBold fontSize="var(--font-body3)" color={stockTextColor}>
          {availableStock}
        </TextSemiBold>
      </Box>
    </Box>
  );
};

export default CardStock;
